import type { ArticleDto, AuthorInfo, AuthorsByAlias, SearchArticleMeta } from "@serophin/nottldr-shared";

/** The keys the public pages' seeds are stored under (`readSeed`), and what each holds. */
export const SEED = {
  landing: "landing",
  articles: "articles",
  authors: "authors",
  author: "author",
  article: "article",
} as const;

export type ArticleListSeed = {
  metas: SearchArticleMeta[];
  authors: AuthorsByAlias;
  nextCursor: string | null;
};

/** The landing page: the popular articles in a fixed order, and the topics the hero types out (shuffled in the browser). */
export type LandingTopic = { category: string; subcategory: string };

export type LandingSeed = ArticleListSeed & { subcategories: LandingTopic[] };

/** The first page of `/authors`. */
export type AuthorsSeed = { authors: AuthorInfo[]; nextCursor: string | null };

/** `/authors/:alias` and `/authors/:alias/articles`: the author, and for the second the first articles. */
export type AuthorSeed = { author: AuthorInfo; list?: ArticleListSeed };

/** `/:alias/:slug`: the article with everything the page shows around it. */
export type ArticleSeed = {
  meta: SearchArticleMeta;
  article: ArticleDto;
  author: AuthorInfo;
  authors: AuthorsByAlias;
  moreFromAuthor: SearchArticleMeta[];
  youMayAlsoLike: SearchArticleMeta[];
};

/** What the page asks the router for: its path parameters and query. */
export type PublicPageParams = { alias?: string; slug?: string };
